import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'cftFileExtension',
  pure: true,
})
export class FileExtensionPipe implements PipeTransform {
  transform(fileName: string | undefined): string | undefined {
    if (fileName && fileName.includes('.')) {
      return fileName.split('.').pop()
    } else {
      return undefined
    }
  }
}
